import { Navigate, Outlet, useLocation } from 'react-router';

import { getAccessToken, isSessionVerified } from '@/shared/lib/tokenStorage';

import { useIsAuthenticated } from './useSession';

/**
 * Route guard for every protected screen.
 *
 * It guards and nothing else — the source app's equivalent also rendered the
 * header and sidebar, which meant the chrome could only ever exist inside a
 * protected route. Here `AppShell` owns layout and this owns access.
 *
 * The attempted location is carried through so a director who follows a deep
 * link into an expired session can be returned to it after signing in again.
 *
 * A half-finished login is its own case. `/director/login` stores tokens
 * before OTP runs, so a director who reloads mid-verification has a token but
 * no verified session. Sending them to `/logout` would make them dig the email
 * back out to start over; `/otp` lets them finish the factor they were already
 * on — the OTP screen recovers the member id from storage when router state
 * did not survive the reload.
 */
export const RequireAuth = () => {
  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();

  if (!isAuthenticated) {
    const isMidLogin = getAccessToken() !== null && !isSessionVerified();
    return <Navigate to={isMidLogin ? '/otp' : '/logout'} state={{ from: location }} replace />;
  }

  return <Outlet />;
};
